import { Box, Grid, Typography } from '@mui/material';
import { useAppSelector } from '../../app/hooks';
import { useGetAssetAvailabilityQuery } from '../../app/redux-fetch/apiAssets';
import DefaultSpacingGrid from '../../components/Containers/DefaultSpacingGrid';
import SpinnerBoxBlock from '../../components/Spinner/SpinnerBoxBlock';
import { fetchLoggedInUserSelector } from '../selectors';
import { ILoggedInUser } from '../types';
import SolidChartComponent from './Components/SolidChartComponent';
import { DashboardTile } from './DashboardTile';

const AssetAvailabilityDashboard = () => {
    const loggedInUser = useAppSelector(fetchLoggedInUserSelector.data) || ({} as ILoggedInUser);
    const { data, isSuccess } = useGetAssetAvailabilityQuery({ tenantId: loggedInUser.tenantId });

    if (!isSuccess) {
        return (
            <DashboardTile sx={{ width: '760px', minHeight: '460px' }}>
                <SpinnerBoxBlock />
            </DashboardTile>
        );
    }

    return (
        <DashboardTile sx={{ width: '760px' }}>
            <DefaultSpacingGrid container>
                <Grid item xs={12}>
                    <Box sx={{ paddingLeft: '20px', paddingTop: '20px' }}>
                        <Typography sx={{ fontSize: '20px', fontWeight: '700', color: '#0A2761' }}>
                            Asset Dashboard
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Box sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'space-between',
                        height: '400px',
                        overflowY: 'auto',
                        borderRadius: '8px'
                    }}>
                        {data.assetCategoryAvailability.map((category) => (
                            <Box key={category.assetCategoryId} sx={{ marginLeft: '20px', width: '100%' }}>
                                <Typography sx={(theme) => ({
                                    width: '100%',
                                    textAlign: 'left',
                                    fontSize: '14px',
                                    fontWeight: '700',
                                    color: theme.palette.primary.main,
                                })}>
                                    {`Asset Category: ${category.assetCategoryName}`}
                                </Typography>
                                {/* The theme zeroes Grid item paddingTop, so the container's
                                    -spacing marginTop would pull it up over the label above. */}
                                <DefaultSpacingGrid container sx={{ marginTop: 0 }}>
                                    {category.assetTypeAvailability.map((assetType) => (
                                        <Grid item xs={6} key={assetType.assetTypeId}>
                                            <Typography sx={(theme) => ({
                                                width: '100%',
                                                textAlign: 'left',
                                                fontSize: '14px',
                                                color: theme.palette.primary.main,
                                            })}>
                                                {assetType.assetTypeName}
                                            </Typography>
                                            <DefaultSpacingGrid container sx={{ marginTop: 0 }}>
                                                {assetType.assetClassAvailability.map((assetClass) => (
                                                    <Grid item xs={6} key={assetClass.assetClassId}>
                                                        <Box sx={{ marginBottom: 2 }}>
                                                            <SolidChartComponent
                                                                data={{ value: assetClass.total, total: data.total }}
                                                                title={assetClass.assetClassName}
                                                            />
                                                        </Box>
                                                    </Grid>
                                                ))}
                                            </DefaultSpacingGrid>
                                        </Grid>
                                    ))}
                                </DefaultSpacingGrid>
                            </Box>
                        ))}
                    </Box>
                </Grid>
            </DefaultSpacingGrid>
        </DashboardTile>
    );
};

export default AssetAvailabilityDashboard;
